// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import merge from "lodash/merge";

export type xRequestQuoteStateType = Readonly<{
    productId: string;
    isAuthenticated?: boolean;
    quoteId: string;
    customerFirstName: string;
    customerLastName: string;
    customerCompanyName: string;
    customerAddressLine1: string;
    customerAddressLine2?: string;
    customerCity: string;
    customerState: string;
    customerZip: string;
    customerPhoneNumber?: string;
    customerEmailAddress: string;
    taxExempt?: boolean;
    taxExemptCertificateNumber?: string;
    orderNote?: string;
}>;

export const initialRequestQuoteState: xRequestQuoteStateType = {
    productId: "",
    isAuthenticated: false,
    quoteId: "",
    customerFirstName: "",
    customerLastName: "",
    customerCompanyName: "",
    customerAddressLine1: "",
    customerAddressLine2: "",
    customerCity: "",
    customerState: "",
    customerZip: "",
    customerPhoneNumber: "",
    customerEmailAddress: "",
    taxExempt: false,
    taxExemptCertificateNumber: "",
    orderNote: "",
};

const reducer = {
    "xRequestQuote/update": (
        draft: Draft<xRequestQuoteStateType>,
        action: { data: Partial<xRequestQuoteStateType> },
    ) => {
        draft = merge(draft, action.data);
    },
};

const xRequestQuote = createTypedReducerWithImmer(initialRequestQuoteState, reducer);

(reducers as any).xRequestQuote = xRequestQuote;

export type xRequestQuoteState = {
    xRequestQuote: xRequestQuoteStateType;
} & ApplicationState;

type xRequestQuoteReducers = {
    [key: string]: typeof xRequestQuote;
};

export type xRequestQuoteActions = Parameters<xRequestQuoteReducers[keyof xRequestQuoteReducers]>[1];
